var helpieUtils = require("../../../helpie-util.js");
var getArticleData = require("./get-articleData.js");
var publishSubmitted = false;

// Nanobar initialization
var nanobar = require("nanobar");
var simplebar = new nanobar();

var publish = {
    init: function () {
        // console.log("publish");
        this.eventHandler();
    },
    eventHandler: function () {
        var thisModule = this;

        jQuery(".article-publish .publish").click(function () {
            if (publishSubmitted) {
                return;
            }
            publishSubmitted = true;

            thisModule.publishArticle();

            setTimeout(function () {
                publishSubmitted = false;
            }, 10000);
        });
    },

    publishArticle: function () {
        var thisModule = this;
        var livePostProps = getArticleData.getLivePostData();

        var data = {
            action: "helpie_publish",
            nonce: thisModule.nonce,
            "action-type": "publish"
        };

        for (prop in livePostProps) {
            data[prop] = livePostProps[prop];
        }
        simplebar.go(100);

        // console.log(livePostProps);
        jQuery.post(my_ajax_object.ajax_url, data, function (response) {
            var props = thisModule.getResultProps(JSON.parse(response));
            thisModule.goToEditMode(props, livePostProps);
            toastr.success(props.noticeMessage);
        });
    },

    goToEditMode: function (props, livePostProps) {
        var current_url = window.location.href;
        current_url = helpieUtils.removeParam("link", current_url);
        if (livePostProps["post_state"] == "add-article") {
            current_url = helpieUtils.removeParam("editor_mode", current_url);
            current_url += "post_id=" + props.post_id;
        }

        if (props.permalink && props.is_article_published) {
            current_url += "&link=" + props.permalink;
        }

        setTimeout(function () {
            window.location.assign(current_url);
        }, 500);
    },

    getResultProps: function (results) {
        var is_article_published = (results.status == 'awaiting' || results.status == 'publish') ? true : false;
        var is_article_sent_for_review = (results.status == 'awaiting' || results.status == 'pending') ? true : false;
        var noticeMessage = is_article_sent_for_review ? helpie_strings.article_submitted_for_review : helpie_strings.article_published;

        return {
            post_id: results.post_id,
            permalink: results.permalink,
            noticeMessage: noticeMessage,
            is_article_published: is_article_published
        };
    }
};

module.exports = publish;
